import { useLayoutContext } from '@/context/layout'
import { cn } from '@/utils/cn'
import type { ReactNode } from 'react'
import { useNavigation } from 'react-router'
import { LoadingBar } from '../common/loadingBar'
import { Header } from './header'
import { TopBar } from './topBar'

interface Props {
  children: ReactNode
}

export function DesktopLayout({ children }: Props) {
  const { isNavbarPinned } = useLayoutContext()
  const navigation = useNavigation()

  return (
    <div
      className={cn(
        'relative grid h-dvh max-h-dvh w-full max-w-full overflow-hidden',
        'grid-cols-1 grid-rows-[var(--top-bar-height),1fr] [grid-template-areas:"topBar""content"]',
        'xl:[grid-template-areas:"leftBar_topBar""leftBar_content"]',
        'transition-all',
        isNavbarPinned
          ? 'xl:grid-cols-[var(--header-expanded-width),1fr]'
          : 'xl:grid-cols-[var(--header-collapsed-width),1fr]'
      )}
    >
      {navigation.state === 'loading' && <LoadingBar className="absolute z-50" />}
      <Header />
      <TopBar />
      <main className="max-h-full max-w-full overflow-hidden [grid-area:content] [view-transition-name:main-content]">
        {children}
      </main>
    </div>
  )
}
